import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  CallDirection,
  CallFieldsFragment,
  CallFilterInput,
  CallReportFieldsFragment,
  CallTranscriptFieldsFragment,
  GetCallDocument,
  GetCallQuery,
  GetCallQueryVariables,
  GetCallReportDocument,
  GetCallReportQuery,
  GetCallReportQueryVariables,
  GetCallsDocument,
  GetCallsQuery,
  GetCallsQueryVariables,
  GetOutboundCallDocument,
  GetOutboundCallQuery,
  GetOutboundCallQueryVariables,
  GetOutboundCallReportDocument,
  GetOutboundCallReportQuery,
  GetOutboundCallReportQueryVariables,
  GetOutboundCallsDocument,
  GetOutboundCallsQuery,
  GetOutboundCallsQueryVariables,
  OutboundCallDetailFieldsFragment,
  OutboundCallFieldsFragment,
  OutboundCallReportFieldsFragment,
  OutboundCallsFilterInput
} from '~/api/graphql';

const inboundCallFilter = (filter?: CallFilterInput): CallFilterInput => ({
  direction: CallDirection.Inbound,
  ...filter
});

export const getCalls = async (filter?: CallFilterInput) =>
  queryData<GetCallsQuery, GetCallsQueryVariables, CallFieldsFragment[]>(
    client,
    { query: GetCallsDocument, variables: { filter: inboundCallFilter(filter) } },
    (data) => data?.calls
  );

export const getCallReport = async (filter?: CallFilterInput) =>
  queryData<GetCallReportQuery, GetCallReportQueryVariables, CallReportFieldsFragment>(
    client,
    { query: GetCallReportDocument, variables: { filter: inboundCallFilter(filter) } },
    (data) => data?.callReport
  );

export const getOutboundCalls = async (filter?: OutboundCallsFilterInput) =>
  queryData<GetOutboundCallsQuery, GetOutboundCallsQueryVariables, OutboundCallFieldsFragment[]>(
    client,
    { query: GetOutboundCallsDocument, variables: filter ? { filter } : {} },
    (data) => data?.outboundCalls
  );

export const getOutboundCall = async (id: string) =>
  queryData<GetOutboundCallQuery, GetOutboundCallQueryVariables, OutboundCallDetailFieldsFragment>(
    client,
    { query: GetOutboundCallDocument, variables: { id: id } },
    (data) => data?.outboundCall
  );

export const getOutboundCallReport = async () =>
  queryData<
    GetOutboundCallReportQuery,
    GetOutboundCallReportQueryVariables,
    OutboundCallReportFieldsFragment
  >(
    client,
    { query: GetOutboundCallReportDocument, variables: {} },
    (data) => data?.outboundCallReport
  );

export const getCall = async (id: string) =>
  queryData<GetCallQuery, GetCallQueryVariables, CallFieldsFragment & CallTranscriptFieldsFragment>(
    client,
    { query: GetCallDocument, variables: { id: id } },
    (data) => data?.call
  );

export const loadCall: LoaderFunction = ({ params }) => loadQuery(getCall(params.id || ''));

export const loadOutboundCall: LoaderFunction = ({ params }) =>
  loadQuery(getOutboundCall(params.id || ''));
